/* eslint-disable sonarjs/no-duplicate-string */
define((require, exports, module) => {
    const $ = require('jQuery');
    const BLayer = require('toolkit/b-layer/b-layer');

    module.exports = BLayer.extend('billing-autopayment-dialog', {
        inner: true,

        hide() {
            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.hide.apply(this, arguments);
        },

        init() {
            this.templateBlock = 'b-layer';

            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.init.apply(this, arguments);
        },

        getData() {
            return $.extend(
                {},
                {
                    canHide: true,
                    block: 'b-panel',
                    mods: ['billing-autopayment-dialog'],
                    params: {
                        mods: ['popup', 'service'],
                        close: true,
                        header: {
                            title: 'Настройка автопополнения',
                        },
                        view: 'billing-autopayment-dialog',
                        content: {},
                    },
                },
            );
        },

        getAutopaymentContainer() {
            return this.$('.js-autopayment');
        },

        destroy() {
            this.off();
            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.destroy.apply(this, arguments);
            this.destroyed = true;
        },
    });
});
